import { render, staticRenderFns } from "./anexoPdf.vue?vue&type=template&id=c3cbc922&lang=pug&"
import script from "./anexoPdf.vue?vue&type=script&lang=js&"
export * from "./anexoPdf.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports